import * as ExcelJS from 'exceljs';

const saveWorkbook = async (headers, csvValues, filename) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('data');
  worksheet.columns = headers.map((header) => ({
    header, key: header, width: 10
  }));

  csvValues.map((value) => worksheet.addRow(value));
  await workbook.xlsx
    .writeBuffer( {
      base64: true
    })
    .then( function (xls64) {
      var a = document.createElement("a");
      var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
      },
      0);
  })
  .catch(function(error) {
      console.log(error.message);
  });
  console.log('Saved to file');
}

export default saveWorkbook;
